export default Object.freeze({
    HOME: 'home',
    O_NAS: 'onas',
    SLUZBY: 'sluzby',
    FOTOGALERIE: 'fotogalerie',
    KONTAKTY: 'kontakty',
    MAPA: 'mapa',
});
